import urlParser from 'js-video-url-parser/lib/base';
import 'js-video-url-parser/lib/provider/vimeo';
import 'js-video-url-parser/lib/provider/youtube';

export enum VideoProvider {
  youtube = 'youtube',
  vimeo = 'vimeo',
}

export interface Autoplayable {
  autoplay: boolean;
}

export interface ControlsDisplayable {
  controls: boolean;
}

export interface YoutubeEmbedOptions extends Autoplayable, ControlsDisplayable {}

// eslint-disable-next-line
export interface VimeoEmbedOptions extends Autoplayable {}

export const FORMAT_EMBED = 'embed';
export const MEDIA_TYPE_VIDEO = 'video';

export default {
  methods: {
    getVideoId(url: string, provider: VideoProvider): string | false {
      const parsed = urlParser.parse(url);
      if (parsed?.provider !== provider || !parsed?.id) {
        return false;
      }

      return parsed.id;
    },
    getYoutubeVideoId(url: string) {
      return this.getVideoId(url, VideoProvider.youtube);
    },
    getVimeoVideoId(url: string) {
      return this.getVideoId(url, VideoProvider.vimeo);
    },
    getYoutubeEmbedUrl(url: string, options: Partial<YoutubeEmbedOptions> = {}) {
      const id = this.getYoutubeVideoId(url);
      const provider = VideoProvider.youtube;
      const params: Record<string, 0 | 1> = { rel: 0 };
      if (options.autoplay) {
        params.autoplay = 1;
      }
      if (options.controls) {
        params.controls = 1;
      }
      return urlParser.create({
        params,
        format: FORMAT_EMBED,
        videoInfo: {
          id,
          provider,
          mediaType: MEDIA_TYPE_VIDEO,
        },
      });
    },
    getVimeoEmbedUrl(url: string, options: Partial<VimeoEmbedOptions> = {}) {
      const id = this.getVimeoVideoId(url);
      const provider = VideoProvider.vimeo;
      const params: Record<string, 0 | 1> = { api: 1 };
      if (options.autoplay) {
        params.autoplay = 1;
      }
      return urlParser.create({
        params,
        format: FORMAT_EMBED,
        videoInfo: {
          id,
          provider,
          mediaType: MEDIA_TYPE_VIDEO,
        },
      });
    },
  },
};
